/**
 * Kalkulator BMI i centyli dziecka DNŻ: warstwa strony.
 *
 * Skrypt niczego nie dorenderowuje poza wykresem: pola, wiersze historii,
 * tabelka stanu A, komunikaty, blokady, CTA i teksty stoją w źródle HTML.
 * Tutaj dzieje się tylko przeliczanie na bieżąco, przełączanie stanów panelu,
 * odsłanianie wierszy historii, rysowanie wykresu (inline SVG) oraz
 * przyklejany pasek nawigacji ze scrollspy (1:1 z białka).
 *
 * Wszystkie obliczenia robi centile-calculator-logic.js (window.DnnzCentileLogic),
 * a liczby przychodzą z konfiguracji osadzonej w <script type="application/json">.
 * Zdania, w które wstawiamy liczby, czytamy z atrybutów data-* szablonu.
 *
 * Stan nie jest nigdzie zapisywany: ani w adresie, ani w magazynie przeglądarki.
 * Wpisane pomiary znikają po odświeżeniu strony.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	var SVG_NS = 'http://www.w3.org/2000/svg';

	function toggle(element, visible) {
		if (element) {
			element.hidden = !visible;
		}
	}

	function attr(element, name) {
		return element ? element.getAttribute(name) || '' : '';
	}

	/** Dzisiejsza data w strefie czasowej czytelnika, zapis RRRR-MM-DD. */
	function todayIso() {
		var d = new Date();
		function two(n) { return (n < 10 ? '0' : '') + n; }
		return d.getFullYear() + '-' + two(d.getMonth() + 1) + '-' + two(d.getDate());
	}

	function initCalculator(root, L) {
		var configEl = root.querySelector('[data-role="config"]');
		if (!configEl) {
			return;
		}
		var cfg;
		try {
			cfg = JSON.parse(configEl.textContent);
		} catch (e) {
			return;
		}

		function q(sel, base) { return (base || root).querySelector(sel); }
		function qa(sel, base) { return Array.prototype.slice.call((base || root).querySelectorAll(sel)); }

		var today = todayIso();
		var el = {
			sex: qa('[data-role="sex"]'),
			sexError: q('[data-role="sex-error"]'),
			birth: q('[data-role="birth"]'),
			birthError: q('[data-role="birth-error"]'),
			measured: q('[data-role="measured"]'),
			measuredError: q('[data-role="measured-error"]'),
			height: q('[data-role="height"]'),
			heightError: q('[data-role="height-error"]'),
			weight: q('[data-role="weight"]'),
			weightError: q('[data-role="weight-error"]'),
			rows: qa('[data-role="history-row"]'),
			add: q('[data-role="h-add"]'),
			limit: q('[data-role="h-limit"]'),
			states: {
				empty: q('[data-state="empty"]'),
				value: q('[data-state="value"]'),
				blocked: q('[data-state="blocked"]')
			},
			blocks: qa('[data-block]'),
			samplesLead: q('[data-role="samples-lead"]'),
			samples: q('[data-role="samples"]'),
			sampleRows: qa('[data-role="sample-row"]'),
			resultLead: q('[data-role="result-lead"]'),
			resultRows: qa('[data-role="result-row"]'),
			resultCaption: q('[data-role="result-caption"]'),
			labels: q('[data-role="category-labels"]'),
			messages: qa('[data-message]'),
			live: q('[data-role="live"]'),
			chartMeasure: qa('[data-role="chart-measure"]'),
			chartTitle: q('[data-role="chart-title"]'),
			chartBox: q('[data-role="chart-box"]'),
			chartEmpty: q('[data-role="chart-empty"]')
		};
		if (!el.states.empty || !el.states.value || !el.birth || !el.measured) {
			return;
		}

		// Odświeżenie strony = stan wyjściowy. Przeglądarka potrafi przywrócić
		// wpisane wartości po odświeżeniu, więc wracamy do wartości z HTML.
		qa('input').forEach(function (input) {
			if (input.type === 'radio') {
				input.checked = input.defaultChecked;
			} else {
				input.value = input.defaultValue;
			}
		});
		el.rows.forEach(function (row) { row.hidden = true; });

		// Data pomiaru domyślnie dzisiejsza; w przyszłość kalendarz nie pozwoli.
		el.measured.value = today;
		[el.birth, el.measured].concat(qa('[data-role="h-date"]')).forEach(function (input) {
			input.setAttribute('max', today);
		});

		// Pole „zatwierdzone” (change: wyjście z pola, Enter, wybór z kalendarza).
		// Komunikat o zbyt małej wartości czeka na zatwierdzenie, żeby nie migał
		// w trakcie pisania; zbyt dużą albo nieliczbę pokazujemy od razu.
		var committed = {};

		function showRangeError(key, raw, invalid, limit) {
			if (!invalid) {
				return false;
			}
			if (committed[key]) {
				return true;
			}
			var v = L.parseNumber(raw);
			return v !== null && (isNaN(v) || v > limit.max);
		}

		function checkedValue(list) {
			for (var i = 0; i < list.length; i++) {
				if (list[i].checked) {
					return list[i].value;
				}
			}
			return null;
		}

		function setError(p, text, input) {
			if (!p) {
				return;
			}
			if (text) {
				p.textContent = text;
			}
			p.hidden = !text;
			if (input) {
				input.setAttribute('aria-invalid', text ? 'true' : 'false');
			}
		}

		function dateErrorText(p, code) {
			if (!code) {
				return '';
			}
			var map = { invalid: 'data-invalid', future: 'data-future', 'before-birth': 'data-before-birth' };
			return attr(p, map[code]);
		}

		// --- Teksty --------------------------------------------------------------

		function ageText(years, months) {
			var y = attr(el.samplesLead, 'data-years').split('|');
			var m = attr(el.samplesLead, 'data-months').split('|');
			var text = years + ' ' + L.plural(years, y);
			if (months > 0) {
				text += attr(el.samplesLead, 'data-join') + months + ' ' + L.plural(months, m);
			}
			return text;
		}

		function dec(v) {
			return L.formatDecimal(v, 1);
		}

		function centileText(cell, display) {
			if (display.bound === 'below') {
				return attr(cell, 'data-below');
			}
			if (display.bound === 'above') {
				return attr(cell, 'data-above');
			}
			return display.value + '.';
		}

		function categoryText(measure, category) {
			var key = measure === 'bmi' && category === 'normal' ? 'data-bmi-normal' : 'data-' + category;
			return attr(el.labels, key);
		}

		function joinList(items, comma, and) {
			if (items.length < 2) {
				return items.join('');
			}
			return items.slice(0, -1).join(comma) + and + items[items.length - 1];
		}

		// --- Stan A: tabelka granic BMI -------------------------------------------

		function renderSamples(s) {
			var t = el.samples;
			var cells = {
				underweight: function (x) { return L.fill(attr(t, 'data-upto'), { x: dec(x.underweightMax) }); },
				normal: function (x) { return L.fill(attr(t, 'data-range'), { x: dec(x.normalMin), y: dec(x.normalMax) }); },
				overweight: function (x) { return L.fill(attr(t, 'data-range'), { x: dec(x.overweightMin), y: dec(x.overweightMax) }); },
				obesity: function (x) { return L.fill(attr(t, 'data-from'), { x: dec(x.obesityMin) }); }
			};
			el.sampleRows.forEach(function (row) {
				var key = row.getAttribute('data-category');
				q('[data-role="sample-F"]', row).textContent = cells[key](s.F);
				q('[data-role="sample-M"]', row).textContent = cells[key](s.M);
			});
			el.samplesLead.textContent = L.fill(attr(el.samplesLead, 'data-template'), { wiek: ageText(s.completedYears, s.extraMonths) });
		}

		// --- Stan B: wynik ---------------------------------------------------------

		function renderResult(e) {
			var r = e.result;
			el.resultLead.textContent = L.fill(attr(el.resultLead, 'data-template-' + r.sex.toLowerCase()), { wiek: ageText(r.age.completedYears, r.age.extraMonths) });
			el.resultRows.forEach(function (row) {
				var m = row.getAttribute('data-measure');
				var res = r[m];
				var valueCell = q('[data-role="value"]', row);
				var unit = attr(valueCell, 'data-unit');
				valueCell.textContent = dec(res.value) + (unit ? ' ' + unit : '');
				var cCell = q('[data-role="centile"]', row);
				cCell.textContent = centileText(cCell, res.display);
				var catCell = q('[data-role="category"]', row);
				catCell.textContent = categoryText(m, res.category);
				row.setAttribute('data-category', res.category);
			});
			el.resultCaption.textContent = L.fill(attr(el.resultCaption, 'data-template'), { siatka: attr(el.resultCaption, 'data-ref-' + r.reference) });

			var wanted = {
				outside: r.outside,
				jump: e.alerts.jump.length > 0
			};
			// Najwyżej cfg.messages.max komunikatów, w kolejności z konfiguracji.
			var show = {};
			cfg.messages.order.filter(function (key) { return wanted[key]; }).slice(0, cfg.messages.max).forEach(function (key) {
				show[key] = true;
			});
			el.messages.forEach(function (p) {
				var key = p.getAttribute('data-message');
				if (key === 'jump' && show.jump) {
					var names = e.alerts.jump.map(function (m) { return attr(p, 'data-' + m); });
					p.textContent = L.fill(attr(p, 'data-template'), { cechy: joinList(names, attr(p, 'data-comma'), attr(p, 'data-and')) });
				}
				toggle(p, !!show[key]);
			});

		}

		// --- Historia ---------------------------------------------------------------

		function rowFields(row) {
			return {
				date: q('[data-role="h-date"]', row),
				height: q('[data-role="h-height"]', row),
				weight: q('[data-role="h-weight"]', row),
				error: q('[data-role="h-error"]', row)
			};
		}

		function updateAddButton() {
			var hidden = el.rows.filter(function (r) { return r.hidden; }).length;
			toggle(el.add, hidden > 0);
			toggle(el.limit, hidden === 0);
		}

		function renderHistoryErrors(e) {
			el.rows.forEach(function (row) {
				var index = +row.getAttribute('data-index');
				var f = rowFields(row);
				var entry = e.history.filter(function (h) { return h.index === index; })[0];
				var text = '';
				var bad = { date: false, height: false, weight: false };
				if (!row.hidden && entry) {
					if (entry.status === 'error') {
						if (entry.errors.date && (entry.errors.date !== 'empty' || committed['h' + index + 'date'] || committed['h' + index + 'height'] || committed['h' + index + 'weight'])) {
							text = attr(f.error, 'data-date-' + entry.errors.date);
							bad.date = true;
						} else if (entry.errors.height && showRangeError('h' + index + 'height', f.height.value, true, cfg.limits.height)) {
							text = attr(f.error, 'data-height-range');
							bad.height = true;
						} else if (entry.errors.weight && showRangeError('h' + index + 'weight', f.weight.value, true, cfg.limits.weight)) {
							text = attr(f.error, 'data-weight-range');
							bad.weight = true;
						}
					} else if (entry.status === 'blocked') {
						text = attr(f.error, 'data-blocked');
					}
				}
				f.error.textContent = text;
				f.error.hidden = !text;
				['date', 'height', 'weight'].forEach(function (k) { f[k].setAttribute('aria-invalid', bad[k] ? 'true' : 'false'); });
			});
		}

		// --- Wykres ------------------------------------------------------------------

		function svg(name, attrs, parent) {
			var node = document.createElementNS(SVG_NS, name);
			Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
			if (parent) {
				parent.appendChild(node);
			}
			return node;
		}

		function renderChart(sex, points) {
			var measure = checkedValue(el.chartMeasure) || cfg.chart.default_measure;
			var box = el.chartBox;
			var old = q('svg', box);
			if (old) {
				box.removeChild(old);
			}
			if (!sex) {
				toggle(el.chartEmpty, true);
				el.chartTitle.textContent = el.chartTitle.getAttribute('data-empty-title') || el.chartTitle.textContent;
				return;
			}
			toggle(el.chartEmpty, false);
			if (!el.chartTitle.getAttribute('data-empty-title')) {
				el.chartTitle.setAttribute('data-empty-title', el.chartTitle.textContent);
			}
			el.chartTitle.textContent = L.fill(attr(el.chartTitle, 'data-template'), { cecha: attr(el.chartTitle, 'data-' + measure), plec: attr(el.chartTitle, 'data-' + sex.toLowerCase()) });

			var data = L.chartData(measure, sex, points, cfg);
			var W = Math.max(280, Math.round(box.clientWidth));
			var H = Math.max(220, Math.round(box.clientHeight));
			var narrow = W < 520;
			var pad = { left: narrow ? 40 : 52, right: narrow ? 30 : 38, top: 12, bottom: narrow ? 40 : 44 };
			var yAxis = L.niceAxis(data.yMin, data.yMax, narrow ? 5 : 7);
			function X(a) { return pad.left + (a - data.xMin) / (data.xMax - data.xMin) * (W - pad.left - pad.right); }
			function Y(v) { return H - pad.bottom - (v - yAxis.min) / (yAxis.max - yAxis.min) * (H - pad.top - pad.bottom); }

			var s = svg('svg', { width: W, height: H, viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': attr(box, 'data-svg-label'), class: 'centile-calculator__svg' });

			// Siatka i osie.
			var grid = svg('g', { class: 'centile-calculator__svg-grid' }, s);
			yAxis.ticks.forEach(function (v) {
				svg('line', { x1: pad.left, x2: W - pad.right, y1: Y(v), y2: Y(v) }, grid);
				var t = svg('text', { x: pad.left - 6, y: Y(v) + 4, 'text-anchor': 'end', class: 'centile-calculator__svg-tick' }, s);
				t.textContent = String(v).replace('.', ',');
			});
			for (var a = data.xMin; a <= data.xMax; a++) {
				svg('line', { x1: X(a), x2: X(a), y1: pad.top, y2: H - pad.bottom, class: a % 3 === 0 ? 'is-major' : '' }, grid);
				if (a % 3 === 0 || !narrow) {
					var tx = svg('text', { x: X(a), y: H - pad.bottom + 16, 'text-anchor': 'middle', class: 'centile-calculator__svg-tick' }, s);
					tx.textContent = a;
				}
			}
			var ax = svg('text', { x: pad.left + (W - pad.left - pad.right) / 2, y: H - 6, 'text-anchor': 'middle', class: 'centile-calculator__svg-axis' }, s);
			ax.textContent = attr(box, 'data-axis-x');
			var ay = svg('text', { x: 12, y: pad.top + (H - pad.top - pad.bottom) / 2, 'text-anchor': 'middle', transform: 'rotate(-90 12 ' + (pad.top + (H - pad.top - pad.bottom) / 2) + ')', class: 'centile-calculator__svg-axis' }, s);
			ay.textContent = attr(box, 'data-axis-' + measure);

			// Linie centyli: ciągłe w całym zakresie 3 do 18 lat.
			var curves = svg('g', { class: 'centile-calculator__svg-curves' }, s);
			data.curves.forEach(function (c) {
				var d = c.points.map(function (p, i) { return (i ? 'L' : 'M') + X(p[0]).toFixed(1) + ' ' + Y(p[1]).toFixed(1); }).join('');
				svg('path', { d: d, class: 'centile-calculator__svg-curve' + (c.centile === 50 ? ' is-median' : '') + (c.centile === 3 || c.centile === 97 ? ' is-limit' : '') }, curves);
				var last = c.points[c.points.length - 1];
				var label = svg('text', { x: X(last[0]) + 4, y: Y(last[1]) + 4, class: 'centile-calculator__svg-label' }, s);
				label.textContent = c.centile;
			});

			// Linia i punkty dziecka.
			var child = data.child.slice().sort(function (p, r) { return p.age - r.age; });
			if (child.length) {
				var g = svg('g', { class: 'centile-calculator__svg-child' }, s);
				if (child.length > 1) {
					svg('path', { d: child.map(function (p, i) { return (i ? 'L' : 'M') + X(p.age).toFixed(1) + ' ' + Y(p.value).toFixed(1); }).join(''), class: 'centile-calculator__svg-line' }, g);
				}
				child.forEach(function (p) {
					svg('circle', { cx: X(p.age).toFixed(1), cy: Y(p.value).toFixed(1), r: p.main ? 6 : 4.5, class: 'centile-calculator__svg-point' + (p.main ? ' is-main' : '') }, g);
				});
			}
			box.appendChild(s);
		}

		// --- Całość -----------------------------------------------------------------

		var lastEval = null;

		function render() {
			var sex = checkedValue(el.sex);
			var history = el.rows.filter(function (r) { return !r.hidden; }).map(function (row) {
				var f = rowFields(row);
				return { index: +row.getAttribute('data-index'), date: f.date.value, height: f.height.value, weight: f.weight.value };
			});
			// Kolejność wierszy nie ma znaczenia (logika sortuje po dacie), ale
			// indeks wiersza musi się zgadzać, żeby komunikat trafił pod właściwy wiersz.
			var raw = { sex: sex, birth: el.birth.value, measured: el.measured.value, height: el.height.value, weight: el.weight.value, history: [] };
			var indexByPosition = [];
			history.forEach(function (h) {
				raw.history.push({ date: h.date, height: h.height, weight: h.weight });
				indexByPosition.push(h.index);
			});
			var e = L.evaluate(raw, cfg, today);
			e.history.forEach(function (h) { h.index = indexByPosition[h.index]; });
			lastEval = e;

			setError(el.birthError, dateErrorText(el.birthError, e.errors.birth), el.birth);
			setError(el.measuredError, dateErrorText(el.measuredError, e.errors.measured), el.measured);
			var hErr = showRangeError('height', el.height.value, !!e.errors.height, cfg.limits.height);
			var wErr = showRangeError('weight', el.weight.value, !!e.errors.weight, cfg.limits.weight);
			toggle(el.heightError, hErr);
			el.height.setAttribute('aria-invalid', hErr ? 'true' : 'false');
			toggle(el.weightError, wErr);
			el.weight.setAttribute('aria-invalid', wErr ? 'true' : 'false');
			toggle(el.sexError, e.needsSex);
			renderHistoryErrors(e);

			renderSamples(e.samples);
			if (e.state === 'value') {
				renderResult(e);
			}
			el.blocks.forEach(function (b) { toggle(b, b.getAttribute('data-block') === e.block); });
			toggle(el.states.empty, e.state === 'empty');
			toggle(el.states.value, e.state === 'value');
			toggle(el.states.blocked, e.state === 'blocked');

			if (el.live) {
				el.live.textContent = e.state === 'value'
					? 'Centyl wzrostu ' + centileText(q('[data-measure="height"] [data-role="centile"]'), e.result.height.display) +
						', masy ciała ' + centileText(q('[data-measure="weight"] [data-role="centile"]'), e.result.weight.display) +
						', BMI ' + centileText(q('[data-measure="bmi"] [data-role="centile"]'), e.result.bmi.display)
					: '';
			}

			renderChart(sex, e.state === 'value' ? e.points : []);
		}

		// Pola tekstowe: przeliczanie przy każdym znaku, błędy po zatwierdzeniu.
		function watch(input, key) {
			if (!input) {
				return;
			}
			input.addEventListener('input', function () {
				committed[key] = false;
				render();
			});
			input.addEventListener('change', function () {
				committed[key] = true;
				render();
			});
		}
		watch(el.birth, 'birth');
		watch(el.measured, 'measured');
		watch(el.height, 'height');
		watch(el.weight, 'weight');
		el.rows.forEach(function (row) {
			var i = row.getAttribute('data-index');
			var f = rowFields(row);
			watch(f.date, 'h' + i + 'date');
			watch(f.height, 'h' + i + 'height');
			watch(f.weight, 'h' + i + 'weight');
			var remove = q('[data-role="h-remove"]', row);
			if (remove) {
				remove.addEventListener('click', function () {
					f.date.value = '';
					f.height.value = '';
					f.weight.value = '';
					['date', 'height', 'weight'].forEach(function (k) { committed['h' + i + k] = false; });
					row.hidden = true;
					updateAddButton();
					render();
					if (el.add && !el.add.hidden) {
						el.add.focus();
					}
				});
			}
		});

		if (el.add) {
			el.add.addEventListener('click', function () {
				var next = el.rows.filter(function (r) { return r.hidden; })[0];
				if (next) {
					next.hidden = false;
					updateAddButton();
					render();
					var first = q('[data-role="h-date"]', next);
					if (first) {
						first.focus();
					}
				}
			});
		}

		el.sex.concat(el.chartMeasure).forEach(function (input) {
			input.addEventListener('change', render);
		});

		// Wykres rysujemy w pikselach pudełka, więc po zmianie szerokości od nowa.
		var resizeTimer = null;
		window.addEventListener('resize', function () {
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(function () {
				if (lastEval) {
					renderChart(checkedValue(el.sex), lastEval.state === 'value' ? lastEval.points : []);
				}
			}, 120);
		});

		updateAddButton();
		render();
	}

	/**
	 * Przyklejany pasek nawigacji ze scrollspy: 1:1 z białka (i spalania).
	 * Pozycję stałą włącza skrypt, a nie position: sticky, bo sticky kończy się
	 * razem z sekcją bloku. W miejscu paska zostaje podstawka o jego wysokości.
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'centile-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;
			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		function updateActive(offset) {
			if (!links.length) {
				return;
			}
			var line = offset + (isFixed ? nav.getBoundingClientRect().height : 0) + 16;
			var current = -1;
			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});
			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}
			if (current === activeIndex) {
				return;
			}
			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}
			activeIndex = current;
			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;
			var offset = headerOffset();
			root.style.setProperty('--cc-sticky-top', offset + 'px');
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;
			if (!isFixed && top <= offset) {
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}
			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);
		update();
	}

	function init() {
		var L = window.DnnzCentileLogic;
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-centile-calculator]'));
		blocks.forEach(function (root) {
			if (L) {
				initCalculator(root, L);
			}
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
